import React, { FC } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Layout } from 'components/layouts/layout';
import { Login } from 'components/pages/login';
import { Home } from 'components/pages/home';
import { Room } from 'components/pages/room';
import { useAccount } from 'hooks/use-account';

export enum Routing {
  LoginPath = '/login',
  HomePath = '/',
  RoomsPath = '/rooms',
  RoomPath = '/rooms/:id',
}

export const Routes: FC = () => {
  const { name } = useAccount();

  // ログイン前
  if (!name) {
    return (
      <Layout>
        <Switch>
          <Route path={Routing.LoginPath} component={Login} exact/>
          <Redirect to={Routing.LoginPath} />
        </Switch>
      </Layout>
    );
  }

  return (
    <Layout>
      <Switch>
        <Route path={Routing.HomePath} component={Home}  exact/>
        <Route path={Routing.RoomPath} component={Room}  exact/>
        <Redirect to={Routing.HomePath} />
      </Switch>
    </Layout>
  );
};
